import { render, staticRenderFns } from "./SetupCompare.vue?vue&type=template&id=3e6d6b26&scoped=true"
import script from "./SetupCompare.vue?vue&type=script&lang=js"
export * from "./SetupCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6d6b26",
  null
  
)

export default component.exports